/**
 * Created by PursuitStar on 2020/07/27
 * Desc: 经销商项目路由表配置
 */
const _import = require('./_import_' + process.env.NODE_ENV);
const receiptRouter = [{
  path: '/receipt/detailList',
  name: 'detailList',
  component: _import('receipt/detailList'),
  hidden: true,
  meta: {
    title: '保证金收据明细'
  },
},{
  path: '/receipt/transform',
  name: 'receiptTransform',
  component: _import('receipt/transform'),
  hidden: true,
  title: '完善电子收据',
  meta: {
    title: '完善电子收据'
  },
},{
  path: '/receipt/list',
  name: 'receiptList',
  component: _import('receipt/list'),
  hidden: true,
  title: '电子收据列表',
  meta: {
    title: '电子收据列表'
  },
},{
  path: '/receipt/terms',
  name: 'receiptTerms',
  component: _import('receipt/terms'),
  hidden: true,
  title: '英树电子收据使用条款',
  meta: {
    title: '英树电子收据使用条款'
  },
  }, {
    path: '/receipt/examineResult',
    name: 'examineResult',
    component: _import('receipt/examineResult'),
    hidden: false,
    meta: {
      title: '电子收据'
    }
  }];
export default receiptRouter;
 


// WEBPACK FOOTER //
// ./src/router/receipt.js